import script from "./GenericEditor.vue?vue&type=script&lang=ts&setup=true"
export * from "./GenericEditor.vue?vue&type=script&lang=ts&setup=true"

import "./GenericEditor.vue?vue&type=style&index=0&id=e1d72502&lang=scss"

const __exports__ = script;

export default __exports__